import React from "react";
import Typography, { TypographyProps } from "@material-ui/core/Typography";

import { fontFamily, fontSize, color } from "style/constants";
import styled from "styled-components";

interface StyledTypographyProps {
  component: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  font?: "primary";
  size?: fontSize;
  fontColor?: color;
  bold?: number;
}

const StyledTypography = styled(({ font, size, fontColor, bold, ...other }) => (
  <Typography {...other} />
))`
  && {
    font-family: ${props => (props.font === "primary" ? fontFamily.primary : fontFamily.secondary)};
    font-size: ${props => (props.size ? props.size : fontSize.large)};
    color: ${props => (props.color ? props.color : color.BLACK)};
    font-weight: normal: ${props => (props.bold ? props.bold : "normal")};
    font-style: normal;
  }
` as React.FC<StyledTypographyProps & TypographyProps>;

interface Props {
  children: React.ReactText;
  tag: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  font?: "primary";
  size?: fontSize;
  fontColor?: color;
  bold?: number;
}
const Heading: React.FC<Props> = ({ children, tag, font, size, fontColor, bold }: Props) => {
  return (
    <StyledTypography component={tag} font={font} size={size} fontColor={fontColor} bold={bold}>
      {children}
    </StyledTypography>
  );
};

export default Heading;
